import type { DeepPartial } from '@luna/utils-ts';
import type { CurrentAccountConfig } from '@shared/products-feature-configs';

import { statements } from '../statements-config/RO';
import { settingsDetails } from '../settings-details-config/RO';

export const currentAccount: DeepPartial<CurrentAccountConfig> = {
    overdraftProgress: {
        enabled: true,
    },
    paymentsEnforced: true,
    statements,
    roundingSavings: {
        enabled: false,
    },
    sepaMandatesRead: {
        enabled: false,
    },
    accountAddress: {
        enabled: false,
    },
    billPayments: {
        enabled: true,
    },
    settingsDetails,
    layout: {
        productInfo: {
            showOwnResourcesWithOverdraftAndDisposableAmounts: true,
            showDisposableAndOverdraftAmount: true,
        },
    },
    dashboard: {
        separateOverdraftAndDisposableDisplay: true,
    },
};
